import React, { useEffect, useState } from 'react';
import MarkdownRenderer from 'react-markdown-renderer';
import styled from 'styled-components';

const MarkdownContainer = styled.div`
  padding: 2.5vw;
  margin-bottom: 3vh;
`;

const Setup = () => {

  const [markdown, setMarkdown] = useState('');
  const path = `${process.env.PUBLIC_URL}/SETUP.md`;

  useEffect(() => {
    fetch(path)
      .then(r => r.text())
      .then(t => {
        setMarkdown(t);
      });
  }, [path]);

  return (
    <MarkdownContainer id="markdown-container">
      <MarkdownRenderer markdown={markdown} options={{ html: true }}/>
    </MarkdownContainer>
  );
};

export default Setup;